<!-- eslint-disable -->
<template lang="pug">
    form.fields(action="javascript://", @submit="sendForm")
        .fields__element(v-if="user && isShowFilter" :style="{width: '100%', padding: 0}")
            label.fields__label {{ $i18n.tc('fields.fields_school', 0) }}
            cs-search-input.fields__input(
                :placeholder="$i18n.t('fields.list_schoolPlaceholder')",
                v-model="form.schoolName"
                @search="sendForm"
        )
        .fields__element(:style="{width: '100%', padding: 0}")
            label.fields__label {{ $i18n.t('fields.fields_period') }}
            cs-datepicker.fields__input(
                :language="user.locale",
                :disabled-dates="dateTo ? {from: new Date(dateTo)} : {}",
                :format="customFormatter",
                v-model="dateFrom"
            )
            .fields__divider —
            cs-datepicker.fields__input(
                :language="user.locale",
                :disabled-dates="dateFrom ? {to: new Date(dateFrom)} : {}",
                :format="customFormatter",
                v-model="dateTo"
            )
        div(:style="{display: 'flex'}")
            .fields__element(:style="{width: 'fit-content', padding: 0}")
                .fields__period-buttons-container
                    a.fields__period-button(
                        v-for="periodValue in periods"
                        href="javascript://"
                        @click="setPeriod(periodValue)"
                    )
                        | {{ $i18n.t(`fields.fields_${periodValue}Period`) }}
            .fields__element(:style="{width: 'fit-content', padding: 0, marginLeft: '30px'}")
                cs-button(
                    color="blue",
                    pattern="primary-outline",
                    html-tag="a"
                    href="javascript://"
                    @click="resetResults",
                    narrow
                )
                    | {{ $i18n.t('fields.fields_dropParameters') }}
</template>

<script>
    /*eslint-disable*/
    import _ from 'lodash';
    import {mapState} from 'vuex';
    import searchParamsStore from '../../utils/searchParamsStore';
    import statusFieldMixin from '../../utils/statusFieldMixin';
    import searchFieldsMixin from '../../../../utils/searchFieldsMixin';
    import moment from 'moment';

    export default {
        mixins: [searchFieldsMixin, searchParamsStore, statusFieldMixin],
        mounted () {
            if (this.$route.name.includes('transactions')) {
                this.type = 'transactions';
                this.dateFrom = moment().startOf('month').format('YYYY-MM-DD');
                this.dateTo = moment().endOf('month').format('YYYY-MM-DD');
                this.form.schoolsTypes = this.$route.params.isStudentPayed ? 'studentPayed' : 'default';
                this.form.studentName = this.$route.params.studentName || "";
                this.form.name = this.$route.params.name || "";
            }
        },
        data() {
            return {
                sort: [{label: this.$i18n.t('fields.list_sortName'), by: 'name'}],
                periods: ['day', 'week', 'month'],
                courses: [],
                form: {
                    sort: null,
                    schoolName: null,
                    status: 'active',
                    accountStatus: null,
                    dateFrom: null,
                    dateTo: null,
                    courses: null,
                    studentName: "",
                    schoolsTypes: "default",
                },
                dateFrom: null,
                dateTo: null,
                type: "",
                schoolsTypes: [
                    'studentPayed',
                    'default'
                ],
                typesNames: {
                    studentPayed: this.$i18n.t('billing.school_with_studentPayed_type'),
                    default: this.$i18n.t('billing.school_with_defaultPayed_type')
                },
                accountStatuses: [
                    'active',
                    'blocked'
                ],
                accountStatusNames: {
                    active: this.$i18n.t('fields.fields_statusActive'),
                    blocked: this.$i18n.t('fields.fields_statusBlocked'),
                }
            }
        },
        watch: {
            '$route.query' (val) {
                if (_.isEmpty(val)) {
                    this.form = _.cloneDeep(this.localSearchParams) || {
                        sort: null,
                        schoolName: null,
                        status: 'active'
                    };
                }
            },
            'form.sort' () {
                this.updateList()
            },
            'form.schoolName'() {
                this.updateList()
            },
            'form.status'() {
                this.updateList()
            },
            'form.accountStatus'() {
                this.updateList()
            },
            'form.courses'() {
                this.updateList()
            },
            'form.studentName'() {
                this.updateList()
            },
            'form.schoolsTypes'() {
                this.updateList()
            },
            'dateFrom'() {
                this.updateList()
            },
            'dateTo'() {
                this.updateList()
            },
        },
        methods: {
            sendForm() {
                if (this.dateFrom) {
                    this.form.dateFrom = moment(this.dateFrom).format('YYYY-MM-DD');
                }
                if (this.dateTo) {
                    this.form.dateTo = moment(this.dateTo).format('YYYY-MM-DD');
                }
                this.$emit(
                    'search',
                    Object.assign({}, this.form, {
                        sort: _.has(this.form, 'sort.by') ? this.form.sort.by : null
                    })
                );
            },
            setPeriod(range) {
                this.dateFrom = moment().startOf(range).format();
                this.dateTo = moment().endOf(range).format();
            },
            resetResults() {
                this.form.sort = null;
                this.dateFrom = this.$moment().startOf('month').format('YYYY-MM-DD');
                this.dateTo = this.$moment().endOf('month').format('YYYY-MM-DD');
                this.form.status = 'active';
                this.form.accountStatus = null;
                this.form.schoolsTypes = 'default';
                this.form.courses = null;
                this.form.studentName = "";
                this.form.schoolName = "";
                this.$nextTick(() => {
                  this.$emit('search', this.form)
                } );
            },
            getTypeName (type) {
                return this.typesNames[type];
            },
            getAccountStatusName(status) {
                return this.accountStatusNames[status];
            },
            customFormatter(date) {
                return moment(date).format('D MMM YYYY');
            },
            updateList: _.debounce(function() {
                this.sendForm()
            }, 1000)
        },
        computed: {
            ...mapState({
                user: state => state.auth.user,
            }),
            isShowFilter () {
                return this.user.isSuperadmin || this.user.isManagerOrSupport;
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../../../assets/sass/fields/fields.scss";
</style>
